/**
 * customInterfaceAggregateOrder_PLANTID
 *  |
 *  -----CustomInterfaceAggregateOrder[]
 *          ----- CustomInterfaceID: AggregatesOrder[]
 *                                  ------- AggregateID: TabOrder
 *              
 */

export class CustomInterfaceAggregateOrder {
    public customInterfaceID: number = 0;
    public aggregatesOrder : AggregateOrder[] = [];

    constructor() {
        this.aggregatesOrder = [];
    }
}

export class AggregateOrder {
    public aggregateID: string = "";
    public aggregateUserTabOrder : number = 999;

    constructor(_aggregateID: string, _aggregateUserTabOrder: number) {
        this.aggregateID = _aggregateID;
        this.aggregateUserTabOrder = _aggregateUserTabOrder;
    }
}
